var _vimeoNoJsLink = '.js-vimeo-play';
var _$vimeoNoJsLink = $(_vimeoNoJsLink);
var _$vimeoPlayers = $('.js-vimeo-player');
var _$vimeoAPI = false;

function _loadVimeoAPI() {
	_$vimeoAPI = document.createElement('script');
	_$vimeoAPI.src = "https://player.vimeo.com/api/player.js";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(_$vimeoAPI, firstScriptTag);
	// console.log('Vimeo API script tag has been added to DOM.');
}

function _initVimeoPlayers() {
	var classes = {
		playState: 'is-playing'
	};
	_$vimeoPlayers.each(function(i, vimeoPlayer) {
		var $vimeoPlayer = $(vimeoPlayer);
		var $vimeoPlayButton = $vimeoPlayer.closest(_vimeoNoJsLink);
		var defaults = {
			id: $vimeoPlayer.attr('data-video'),
			loop: false
		};
		var autoplay = ( $vimeoPlayer.hasClass('autoplay') ) ? true : false;
		var autoplayOptions = {};
		if( autoplay ) {
			autoplayOptions = {
				autoplay: true
			};
		}
		var params = $.extend(true, defaults, autoplayOptions);
		var player = new Vimeo.Player(vimeoPlayer, params);
		if( autoplay ) {
			player.setVolume(0);
			player.play();
			$vimeoPlayButton.addClass(classes.playState);
		}
		$vimeoPlayButton.on('click', function(e) {
			e.preventDefault();
			$(this).addClass(classes.playState);
			player.play().then(function() {
				// console.log('Played the Vimeo video from a custom button.');
			});
		});
		player.on('play', function() {
			// console.log('Played the Vimeo video.');
		});
		player.on('ended', function() {
			// console.log('Vimeo playback complete.');
			$vimeoPlayButton.removeClass(classes.playState);
		});
	});
}

if (_$vimeoPlayers.length) {
	_loadVimeoAPI();
}

if( _$vimeoAPI ) {
	_$vimeoAPI.onload = function() {
		// console.log(typeof _$vimeoAPI);
		// console.log('Vimeo API has loaded.');
		_initVimeoPlayers();
	};
}
